import { render, staticRenderFns } from "./QuotesDetailView.vue?vue&type=template&id=e38c0f6c&scoped=true&"
import script from "./QuotesDetailView.vue?vue&type=script&lang=js&"
export * from "./QuotesDetailView.vue?vue&type=script&lang=js&"
import style0 from "./QuotesDetailView.vue?vue&type=style&index=0&id=e38c0f6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e38c0f6c",
  null
  
)

export default component.exports